import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Page, { PageActionsType } from "components/common/page/Page";
import SeasonDatalist from "components/entities/app/season/SeasonDatalist";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const SeasonDatalistPage = () => {
    const context = useAppContext();

    const pageActions: PageActionsType = [
        { 
            link: AppRoutes.SEASON_FORM, 
            icon: faPlus, 
            name: 'edit', 
            title: context.t('button.edit'),
            hide: !context.userHasRole(Roles.ADMIN)
        }
    ]

    return (
        <Page title="pages.season.list" wFull actions={pageActions}>
            <SeasonDatalist
                name="season-datalist-page"
                onItemClick={{ link: { url: AppRoutes.SEASON_VIEW, params: i => ({ id: i.id }) } }}
            />
        </Page>
    );
}

export default SeasonDatalistPage;
